import { useFormikContext } from 'formik';
import { ReactNode } from 'react';
import capitalize from '~/utils/string';

interface FormControlProps {
  name: string;
  label?: string;
  isRequired?: boolean;
  children: ReactNode;
}

const FormControl = ({
  name,
  label,
  isRequired = false,
  children,
}: FormControlProps) => {
  const {
    touched,
    errors,
  }: {
    touched: { [key: string]: any };
    errors: { [key: string]: any };
  } = useFormikContext();

  const isTouched = touched?.[name];
  const error = errors?.[name];
  const shouldShowError = isTouched && error;

  return (
    <label htmlFor={name}>
      {label && (
        <p className=" c-label--modal">
          {label}
          {isRequired && <sup>*</sup>}
        </p>
      )}
      {children}
      {shouldShowError && (
        <span className="c-error mt-1">{capitalize(error || '')}</span>
      )}
    </label>
  );
};

export default FormControl;
